import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService, AppRole } from 'src/app/services/auth-service';

export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    router.navigateByUrl('/login', { replaceUrl: true });
    return false;
  }

  const allowedRoles = (route.data?.['roles'] || []) as AppRole[];

  if (allowedRoles.length === 0) {
    return true;
  }

  if (auth.hasRole(allowedRoles)) {
    return true;
  }

  router.navigateByUrl('/dashboard', { replaceUrl: true });
  return false;
};